import { ShoppingCart, Printer, Play, Flame, ArrowLeft, Video, ArrowRight } from "lucide-react";
import useSectionInView from '../useSectionInView';
import '../sectionAnimations.css';

const steps = [

  {
    icon: ShoppingCart,
    label: "קונים",
    color: "bg-primary",
  },
    {
    icon: Printer,
    label: "מדפיסים",
    color: "bg-secondary",
  },
    {
    icon: Play,
    label: "מפעילים",
    color: "bg-accent",
  },
    {
    icon: Flame,
    label: "אש!",
    color: "bg-primary",
  }
];

const HowItGoes = () => {
  const [ref, visible] = useSectionInView();
  return (
    <section ref={ref} className=".hiw-section-root section-padding bg-muted">
      <div className="container-main">

        {/* Steps */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
          {steps.map((step, index) => (
            <div
              key={step.label}
              className={`flex items-center gap-4 md:gap-8 section-slide-in-right${visible ? ' visible' : ''}`}
              style={{ transitionDelay: visible ? `${index * 0.18}s` : '0s' }}
            >
              <div className="flex flex-col items-center gap-3 group">
<div
  className={`${step.color} w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12`}
>
  <step.icon className="w-8 h-8 md:w-10 md:h-10 text-white" />
</div>
                <span className="font-bold text-foreground text-lg">{step.label}</span>
              </div>
              
{index < steps.length - 1 && (
  <div
    className="text-3xl font-bold hidden sm:block"
    style={{ color: `hsl(var(--${steps[index].color.replace('bg-', '')}))` }}
  >
    ←
  </div>
)}


            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mt-12">
          <button className="btn-outline-green px-4 py-1.5 gap-2 h-10.5">
            <ArrowLeft className="w-5 h-5 text-secondary" />
            לכל התוכניות
          </button>
          <button className="btn-secondary flex items-center px-4 py-1.5 gap-2 h-10.5 rounded-lg">
            <Video className="w-5 h-5" />
            לצפייה בהדגמה
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItGoes;